import { Modal } from 'components/modal/modal'
import React from 'react'
import { Button } from 'ui-kit/button'

import { ButtonContainer, Description, ModalContainer, Title } from './CancellationModal.styles'

interface CancellationModalProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
}

export const CancellationModal: React.FC<CancellationModalProps> = ({ isOpen, onClose, onConfirm }) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} center fluid>
      <ModalContainer>
        <Title>Cancel Subscription</Title>
        <Description>
          Are you sure you want to cancel your subscription? You will lose access to premium features at the end of your
          current billing period.
        </Description>
        <ButtonContainer>
          <Button variant="secondary" onClick={onClose}>
            Keep Subscription
          </Button>
          <Button variant="primary" onClick={onConfirm}>
            Confirm Cancellation
          </Button>
        </ButtonContainer>
      </ModalContainer>
    </Modal>
  )
}
